@if (!hidden) {
  @if (elementType === "button") {
    <button
      [attr.form]="form"
      [id]="buttonId"
      [name]="buttonId"
      [title]="buttonTitle"
      [attr.aria-pressed]="pressed"
      (click)="onClick($event)"
      [type]="buttonType"
      [attr.aria-describedby]="describedBy"
      [attr.aria-label]="buttonLabel"
      [ariaDisabled]="disabled ? 'true' : 'false'"
      [class]="
        'flex items-center w-full flex-shrink-0 lg:hover:font-bold transition-transform-slow' +
        ' ' +
        (disabled ? 'opacity-70 button-disabled ' : '') +
        (flexGap ? flexGap : '') +
        ' ' +
        justifyContent
      "
      [ngClass]="customClasses"
    >
      @if (icon) {
        <app-icon
          [name]="icon.iconType"
          [width]="icon.iconWidth"
          [height]="icon.iconHeight"
          [rotate]="icon.iconRotation"
          [color]="icon.iconColor"
          [customClasses]="icon.iconClass"
          [customHostClasses]="icon.placement === 'left' ? '' : 'order-2'"
          [attr.aria-hidden]="true"
        ></app-icon>
      }
      @if (buttonText) {
        <span class="text-center" [ngClass]="buttonCustomCss">{{
          buttonText
        }}</span>
      }

      @if (icon && icon.placement === "left") {
        <div class="w-0 h-0" aria-hidden="true"></div>
      }
    </button>
  } @else {
    <a
      tabindex="0"
      [routerLink]="routerLink ? routerLink : []"
      [fragment]="fragmentLink"
      [id]="buttonId"
      [title]="buttonTitle"
      (click)="onClick($event)"
      [attr.aria-describedby]="describedBy"
      [attr.aria-label]="buttonLabel"
      [class]="
        'flex items-center w-full p-2 flex-shrink-0 lg:hover:font-bold no-underline font-inherit' +
        (flexGap ? ' ' + flexGap : '') +
        ' ' +
        justifyContent
      "
      [ngClass]="customClasses"
    >
      @if (icon) {
        <app-icon
          [name]="icon.iconType"
          [width]="icon.iconWidth"
          [height]="icon.iconHeight"
          [rotate]="icon.iconRotation"
          [color]="icon.iconColor"
          [customClasses]="icon.iconClass"
          [customHostClasses]="icon.placement === 'left' ? '' : 'order-2'"
          [attr.aria-hidden]="true"
        ></app-icon>
      }
      <span class="flex-grow text-center">{{ buttonText }}</span>

      @if (icon && icon.placement === "left") {
        <div class="w-0 h-0" aria-hidden="true"></div>
      }
    </a>
  }
}
